module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"files:to-attach":"Прикрепить вложение не более 5 Мб","files:upload-desc":"Перетяните файл в это поле или выберите вручную"},"en":{"files:to-attach":"Attach file","files:upload-desc":"Drag the file to this field or select manually"}}')
  delete Component.options._Ctor
}
